import React from "react";
import { MenuProps } from "./Menu.types";
import { MenuContainer } from "./Menu.style";
import { MdClose, MdMenu } from "react-icons/md";
import Modal from "../../Modal/Modal";
import PropertySearch from "../../PropertySearch/PropertySearch";

interface HeaderState {
  isMenuOpen: boolean;
  isModalOpen: boolean;
}

export default class Menu extends React.Component<MenuProps, HeaderState> {
  menuRef: React.RefObject<HTMLDivElement>;
  closeIconRef: React.RefObject<HTMLDivElement>;
  menuIconRef: React.RefObject<HTMLDivElement>;

  constructor(props: MenuProps) {
    super(props);

    this.state = {
      isMenuOpen: false,
      isModalOpen: false,
    };

    this.menuRef = React.createRef();
    this.closeIconRef = React.createRef();
    this.menuIconRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleKeyDown);
    this.enableScroll();
  }

  toggleMenu = () => {
    this.setState(
      (prevState) => ({ isMenuOpen: !prevState.isMenuOpen }),
      () => {
        if (this.state.isMenuOpen) {
          if (this.isMobile()) {
            this.disableScroll();
          }
          this.focusCloseIcon();
        } else {
          this.enableScroll();
          this.focusMenuIcon();
        }
      }
    );
  };

  closeMenu = () => {
    this.setState({ isMenuOpen: false }, () => {
      this.enableScroll();
      this.focusMenuIcon();
    });
  };

  handleClickOutside = (event: MouseEvent) => {
    if (
      this.menuRef.current &&
      !this.menuRef.current.contains(event.target as Node) &&
      this.closeIconRef.current &&
      !this.closeIconRef.current.contains(event.target as Node)
    ) {
      this.closeMenu();
    }
  };

  handleKeyDown = (event: KeyboardEvent) => {
    if (this.state.isMenuOpen) {
      if (event.key === "Tab") {
        const focusableElements = this.menuRef.current?.querySelectorAll(
          "a, button, [tabindex]:not([tabindex='-1'])"
        );
        if (!focusableElements || focusableElements.length === 0) return;

        const firstElement = focusableElements[0] as HTMLElement;
        const lastElement = focusableElements[focusableElements.length - 1] as HTMLElement;

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  };

  handleMenuIconKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter") {
      this.toggleMenu();
    }
  };

  handleCloseIconKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      this.closeMenu();
    }
  };

  focusCloseIcon = () => {
    if (this.closeIconRef.current) {
      this.closeIconRef.current.focus();
    }
  };

  focusMenuIcon = () => {
    if (this.menuIconRef.current) {
      this.menuIconRef.current.focus();
    }
  };

  isMobile = () => {
    return window.innerWidth <= 768;
  };

  disableScroll = () => {
    document.body.style.overflow = "hidden";
  };

  enableScroll = () => {
    document.body.style.overflow = "";
  };

  handleButtonSearchClick = () => {
    this.closeMenu();
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  openModalSearch = () => {

  };

  render() {
    const { isMenuOpen, isModalOpen } = this.state;
    const { listaMenu } = this.props;

    return (
      <>
        <MenuContainer ref={this.menuRef}>
          <div
            className="menu-icon-link"
            onClick={this.toggleMenu}
            onKeyDown={this.handleMenuIconKeyDown}
            tabIndex={0}
            ref={this.menuIconRef}
          >
            <MdMenu className="menu-icon" />
          </div>
          {isMenuOpen && (
            <nav className="nav-menu">
              <div className="menu-header">
                <div
                  className="close-icon-container"
                  onClick={this.closeMenu}
                  onKeyDown={this.handleCloseIconKeyDown}
                  tabIndex={0}
                  ref={this.closeIconRef}
                >
                  <MdClose className="close-icon" />
                </div>
              </div>
              <ul>
                {listaMenu?.map((item) => (
                  item.textMenuItem?.includes('Encontre') ? (
                    window.innerWidth <= 768 ? (
                      <li key={item.linkMenu}>
                        <a href="#" onClick={this.handleButtonSearchClick}>
                          {item.textMenuItem}
                        </a>
                      </li>
                    ) : (
                      <li key={item.linkMenu} style={{ display: "none" }} />
                    )
                  ) : (
                    <li key={item.linkMenu}>
                      <a href={item.linkMenu} onClick={this.closeMenu}>
                        {item.textMenuItem}
                      </a>
                    </li>
                  )
                ))}
              </ul>
            </nav>
          )}

          {isModalOpen && (
            <Modal onClose={this.closeModal} onReturn={Function} returnDisabled={true}>     
            {listaMenu?.map((item) => 
              <PropertySearch backgroundColor={""} title={""} isInEditor={false} cqPath={""} titleSearch={"Encontre ofertas imperdíveis na sua região"} textSearch={""} mcmvChecker={false} buttonSearch={""} iconCheck={false} pageSearchUrl={ item.linkMenu ? item.linkMenu : "/content/conhecer/br/pt/resultado-da-busca.html"}></PropertySearch>
            )}
            </Modal>
          )}
        </MenuContainer>
      </>
    );
  }
}
